<template>
  <modal @close="$emit('close')" :click_outside="false">
    <p class="text-white font-bold xl:-mt-10 lg:-mt-10 -mt-5 text-xl mt-2" slot="header">Восстановить пароль</p>
    <div class="pb-8 xl:-mt-12 lg:-mt-12 pt-2 px-8">
      <div class="mb-8">
        <moz-input
          v-model="form.email"
          placeholder="E-mail"
          type="email"
          :error="form.errors.first('email')"
        ></moz-input>
      </div>
      <button
        @click.prevent="restore_account"
        class="flex justify-center outline-none hover-up items-center mx-auto bg-brand-light w-2/3 h-10 text-white rounded-full font-bold mt-10 hover:bg-brand-yellow hover:text-main-text"
      >Восстановить</button>
    </div>
  </modal>
</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
import Modal from '@/views/modals/base-modal';
import base from '@/clients/base.js';
import Form from 'form-backend-validation';

export default {
  name: 'RecoveryAccount',
  components: { Modal },
  props: ['recovery_account'],
  mixins: [ModalMixin],
  data() {
    return {
      form: new Form(
        {
          email: '',
        },
        { http: base },
      ),
      ext: '',
      show: false,
      loaded: false,
    };
  },
  methods: {
    restore_account() {
      this.form.post('password/email').then((response) => {
        this.$emit('restore_account', { recovery_account: true });
        this.vale = !this.vale;
      });
    },
  },
};
</script>

<style scoped>
.border-brand {
  outline: none;
  border-bottom-color: #bd006c !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-width: 1px;
}
</style>
